import React from "react";
import { HelmetProvider } from 'react-helmet-async';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ChatWidget from './components/ui/ChatWidget';
import CookieConsentBanner from './components/ui/CookieConsentBanner';
import SessionManager from './components/SessionManager';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <Routes />
          <SessionManager />
          <ChatWidget />
          <CookieConsentBanner />
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;